var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"GameDetail"}},[_c('div',{staticClass:"detail_block"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail_info.title))]),_vm._v(" "),_c('p',{staticClass:"other"},[_vm._v(_vm._s(_vm.detail_info.other))]),_vm._v(" "),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.detail_info.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3610e50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/GameDetail.vue
// module id = null
// module chunks = 